// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LrrModel from '../../model/lrr-model';
import LrrDTO from '../dto/lrr-dto';
import dtoSchema from '../schemas/lrr-schema';

export default abstract class LrrModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LrrDTO>) {
    super();
    if (data) {
      this.chain = data.chain ?? undefined;
      this.lrrESP = data.lrrESP ?? undefined;
      this.lrrRSSI = data.lrrRSSI ?? undefined;
      this.lrrSNR = data.lrrSNR ?? undefined;
      this.lrrid = data.lrrid ?? undefined;
    }
  }
  /**
  * @type {int32}
  */
  chain?: number;
  /**
  * @type {float}
  */
  lrrESP?: number;
  /**
  * @type {int32}
  */
  lrrRSSI?: number;
  /**
  * @type {float}
  */
  lrrSNR?: number;
  /**
  */
  lrrid?: string;

  static toModel(dto: DeepPartial<LrrDTO>): LrrModel;
  static toModel(dto: DeepPartial<LrrDTO> | undefined | null): LrrModel | undefined;
  static toModel(dto: DeepPartial<LrrDTO> | undefined | null): LrrModel | undefined {
    return dto ? new LrrModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LrrModel> | LrrModel): LrrDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      chain: unwrapped.chain,
      lrrESP: unwrapped.lrrESP,
      lrrRSSI: unwrapped.lrrRSSI,
      lrrSNR: unwrapped.lrrSNR,
      lrrid: unwrapped.lrrid,
    } as LrrDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LrrModel, can not map to LrrDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
